import React from 'react';
export function Footer() {
  return <footer className="bg-[#0B1F4D] border-t-4 border-[#F5C400] py-10 px-4 text-center" data-id="element-137" data-mp="32wd2qgad7ltj">
      <p className="text-xs text-white/60 max-w-3xl mx-auto mb-4 leading-relaxed" data-id="element-138" data-mp="3ggtymjf7hl5r">
        Educational teaching-support material for electrical instructors, technical schools, vocational programs and
        training workshops. It does not replace an accredited electrical curriculum, electrician licensing or official
        certifications, local electrical codes and regulations, your equipment manufacturer&apos;s instructions, workplace
        safety training and rules, or qualified professional supervision. Always follow your institution&apos;s safety
        procedures, lockout/tagout rules and the applicable codes and standards. Results depend on each instructor,
        student and learning context; no specific results are guaranteed.
      </p>
      <p className="text-sm text-white/80" data-id="element-139" data-mp="2eyt7klbanzop">© Electrical Technology Instructor Atlas 2026 — All Rights Reserved.</p>
    </footer>;
}